import IconButton from "../../components/button/IconButton";
import * as React from "react";
import {ButtonGroup, Tab} from "react-bootstrap";
import { useModels } from "../../helpers/models";
import ConfirmIconButton from "../../components/button/ConfirmIconButton";
import FontInventoryHistoryTableConfig from "./FontInventoryHistoryTableConfig";
import Table from "../../components/table/Table";
import {hasFontManagementFullAccess} from "../../helpers/jwt";
import { useTranslation } from 'react-i18next';

export function FontTableActions(props) {

    const { t } = useTranslation();
    const models = useModels();
    const buttonSize = "md"

    const inventoryCreated = (inventoryId) => {
        props.setLoader(false)
        goToInventory(inventoryId)
    }

    function goToInventory(inventoryId) {
        props.history.push(`/font/${props.row.machine.id}/inventory/${inventoryId}`)
    }

    return <div className={"d-flex"}>
        <ButtonGroup>

            <IconButton
                variant={"outline-primary"}
                // className="btn-circle ml-1"
                onClick={() => props.history.push("/font/" + props.row.machine.id)}
                size={buttonSize}
                tooltip={t("menu.font_management")}
                disabled={!props.row.exists}
                icon={models.font.icon}
            />
            {!props.row.activeFontInventory && hasFontManagementFullAccess() &&
                <ConfirmIconButton
                    variant={"outline-primary"}
                    onConfirm={() => {
                        props.createInventory(props.row.machine.id, inventoryCreated)
                    }}
                    size={buttonSize}
                    tooltip={t("tooltips.start_inventory")}
                    icon={models.icons.start}
                    modalSize={"md"}
                    disabled={!props.row.exists}
                    confirmTitle={t("confirmations.start_inventory_title")}
                    confirmDescription={t("confirmations.are_you_sure_start_inventory")}
                />
            }
            {props.row.activeFontInventory && hasFontManagementFullAccess() &&

                <IconButton
                    variant={"primary"}
                    // className="btn-circle ml-1"
                    onClick={() => {
                        goToInventory(props.row.activeFontInventory);
                    }}
                    size={buttonSize}
                    tooltip={t("tooltips.continue_inventory")}
                    disabled={!props.row.exists}
                    icon={models.icons.start}
                />
            }
            <ConfirmIconButton
                confirmTitle={t("common.inventory_history")}
                size={"md"}
                tooltip={t("common.inventory_history")}
                variant={"outline-primary"}
                icon={"fa-clock-rotate-left"}
                modalSize={"xl"}
                alert={true}
                modelChildren={
                    <Table
                        source={"/fontInventory/history/" + props.row.machine.id}
                        setLoader={props.setLoader}
                        columns={FontInventoryHistoryTableConfig(t)}
                    />
                }

            />
            {/*<IconButton*/}
            {/*    variant={"outline-primary"}*/}
            {/*    // className="btn-circle ml-1"*/}
            {/*    onClick={() => props.history.push(models.management.url + "/" + props.row.id)}*/}
            {/*    size={buttonSize}*/}
            {/*    tooltip={"Rozpocznij inwente"}*/}
            {/*    disabled={props.row.formatStatus === "CREATION_STARTED"}*/}
            {/*    icon={"fa-bars-progress"}*/}
            {/*/>*/}

        </ButtonGroup>

    </div>;
}